import { Box, Button, Grid, IconButton, LinearProgress, linearProgressClasses, Stack, styled, Typography } from "@mui/material";
import { VIEW } from "../../../../utils/breakpoint";
import { AccessTimeFilled, ArrowBackIosNew } from "@mui/icons-material";
import { getStatusColor } from "../../../../utils/ColourStatus";
import { getJobStatusLabel } from "../../../../utils/enums/JobEnums";
import cleanIcon from '../../../../assets/cleaning/clean-icon.png';
import { GridCloseIcon } from "@mui/x-data-grid";
import { COLOR } from "../../../../utils/colors";
import { CLEANING_JOB_STATUS, getCleaningTypeLabel, useDetailCleaningJob, useUpdateCleaningJobMutation } from "../../../../hooks/cleaning";
import { getProfile } from "../../../../utils/api";
import dayjs from "dayjs";
import { parseAsBoolean, useQueryState } from "nuqs";
import { SHOW_ZONE_QUERY_PARAM } from "../../../../utils/const";
import { useWebSocket } from "../../../../components/useWebSocket";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: '#D0D5DD',
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: '#53DC9C',
  },
}));

export default function DetailCleaningJobBoard({
  handleBackButton,
  handleCloseButton,
  // job,
  task_id,
}: {
  handleBackButton?: () => void
  handleCloseButton?: () => void
  // job?: DataCleaningJobType
  task_id?: string
}) {
  const organisation_id = getProfile()?.organisation
  const { data: job, isLoading, refetch } = useDetailCleaningJob({
    organisation_id,
    task_id,
    enabled: !!organisation_id && !!task_id,
  })

  const [, setShowZone] = useQueryState(SHOW_ZONE_QUERY_PARAM, parseAsBoolean.withOptions({
    clearOnDefault: true
  }).withDefault(false));

  // useEffect(() => {
  //   if (!job || isLoading) {
  //     return
  //   }

  //   setShowZone(true)
  //   const timer = setTimeout(() => {
  //     refetch()
  //   }, 3000)

  //   return () => {
  //     clearTimeout(timer)
  //   }
  // }, [job, isLoading])

  const handleReceiveJobs = () => {
    refetch()
  }

  const jobOverviewUrl = `${process.env.REACT_APP_WEBSOCKET_URL}/cleaning_job_status/${organisation_id}/`;
  useWebSocket(jobOverviewUrl, handleReceiveJobs);

  const getPercentageValue = (percentage: number) => {
    if (isCompleted) {
      return 100
    }
    return parseInt((percentage * 100) + '')
  }

  const estimatedTime = () => {
    if (!job) {
      return '-'
    }

    const start_time = job.start_time
    if (!start_time) {
      return '-'
    }

    if (job.estimated_time_remaining === 0 || !job.estimated_time_remaining) {
      return '-'
    }

    const estResult = dayjs(new Date()).add(job.estimated_time_remaining || 0, 'second').format("DD MMM YYYY, hh:mm A")
    return estResult;
  }

  const { trigger: cancelJob } = useUpdateCleaningJobMutation({
    organisation_id,
    task_id: task_id || '',
    onSuccess: () => {
      refetch()
    }
  })
  const handleCancelJob = () => {
    cancelJob({
      status: CLEANING_JOB_STATUS.CANCELLED
    })
  }

  const isCancelled = job?.status.toLowerCase() === CLEANING_JOB_STATUS.CANCELLED.toLowerCase()
  const isFailed = job?.status.toLowerCase() === CLEANING_JOB_STATUS.FAILED.toLowerCase()
  const isCompleted = job?.status.toLowerCase() === CLEANING_JOB_STATUS.COMPLETED.toLowerCase()
  return (
    <Stack
      sx={(theme) => ({
        [theme.breakpoints.up(VIEW.PHONE)]: {
          position: 'fixed',
          inset: 0,
          height: '100dvh',
          width: '100vw',
          zIndex: 1100,
          marginTop: '0px !important',
          // paddingBottom: '24px'
        },
        [theme.breakpoints.up(VIEW.TABLET)]: {
          position: "absolute",
          top: "60px",
          left: 'auto',
          bottom: 'auto',
          right: "20px",
          width: "400px",
          height: 'auto',
          maxHeight: "450px",
          zIndex: 1005
        },
        [theme.breakpoints.up(VIEW.DESKTOP)]: {
          top: "60px",
          height: "auto",
        },
        opacity: 1,
        bgcolor: "white",
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        borderRadius: "10px",
        overflowY: "hidden",
        overflowX: "hidden",
        transition: 'all',
        transitionDuration: '300ms',
      })}>
      {!!job && (
        <>
          <Box sx={(theme) => ({
            [theme.breakpoints.down(VIEW.TABLET)]: {
              height: "300px",
            },
            [theme.breakpoints.up(VIEW.TABLET)]: {
              height: "190pxx",
            },
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)",
            display: "flex",
            flexDirection: "column",
          })}>
            <Stack sx={{
              position: "absolute",
              top: "20px",
              left: "15px",
            }}>
              <IconButton onClick={handleBackButton}>
                <ArrowBackIosNew sx={{ color: "#000", fontSize: "15px" }} />
              </IconButton>
            </Stack>
            <Stack
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                padding: "10px",
                m: 1.5,
                ml: 4.5

              }}>
              <Stack sx={{ width: "60px", height: "60px", bgcolor: "#f4f4f4", color: "white", fontWeight: "600", borderRadius: "30px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <img src={cleanIcon} style={{ width: "30px", height: "30px", objectFit: 'scale-down' }} />
              </Stack>
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "left", m: 1, ml: 4 }}>
                <Typography sx={{ color: "#000", fontSize: "20px", fontWeight: "600" }}>
                  {job.task_name}
                </Typography>
                <Typography sx={{ color: getStatusColor(job.status.toLowerCase().split(" ").join("_")), fontSize: "14px" }}>
                  {getJobStatusLabel(job.status.toLowerCase().split(" ").join("_"))}
                </Typography>
              </Box>
              <Stack sx={{
                position: "absolute",
                top: "15px",
                right: "15px",
              }}>
                <IconButton onClick={handleCloseButton}>
                  <GridCloseIcon sx={{ color: "#000", fontSize: "20px" }} />
                </IconButton>
              </Stack>
            </Stack>

            <Box sx={{ display: 'flex', flexDirection: 'column', px: '25px', py: '10px' }}>
              <Typography sx={{ color: "#9F9F9F", fontSize: "14px", textAlign: 'left', mb: 0.5 }}>
                Progress Status
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'row', gap: '12px', alignItems: 'center', width: '100%' }}>
                <Box sx={{ flex: 'auto' }}>
                  <BorderLinearProgress
                    variant="determinate"
                    value={getPercentageValue(isCancelled || isFailed ? 0 : job.percentage)}
                    sx={{
                      height: '10px',
                    }}
                  />
                </Box>
                <Typography sx={{ color: COLOR.black, flex: 'none', fontSize: "14px", textAlign: 'left' }}>
                  {getPercentageValue(isCancelled || isFailed ? 0 : job.percentage) || '0'}%
                </Typography>
              </Box>
            </Box>

            {!!job.last_updated_time && (
              <Box sx={{ px: '25px', pb: '10px' }}>
                <Typography sx={{ color: COLOR.gray[400], fontSize: '12px' }}>
                  Last Updated at: {dayjs(job.last_updated_time).format("DD MMM YYYY hh:mm a")}
                </Typography>
              </Box>
            )}

          </Box>
          <Box sx={{ overflow: "auto", }}>
            <Box sx={{
              display: "flex", flex: 'auto', flexDirection: "column",
              px: '25px', py: '25px',
              gap: '10px'
            }}>
              <Grid container sx={{ width: '100%' }}>
                <Grid item xs={12} sm={4} sx={{ display: "flex", flexDirection: "column", alignItems: "left", mb: 2 }}>
                  <Typography sx={{ color: "#9F9F9F", fontSize: "12px", fontFamily: 'Poppins, Roboto' }}>
                    Robot
                  </Typography>
                  <Typography sx={{ color: "#000", fontSize: "16px", fontFamily: 'Poppins, Roboto' }}>
                    {job.robot_id || '-'}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4} sx={{ display: "flex", flexDirection: "column", alignItems: "left", mb: 2 }}>
                  <Typography sx={{ color: "#9F9F9F", fontSize: "12px", fontFamily: 'Poppins, Roboto' }}>
                    Cleaning Area
                  </Typography>
                  <Typography sx={{ color: "#000", fontSize: "16px", fontFamily: 'Poppins, Roboto' }}>
                    {job.areas.join(',') || '-'}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4} sx={{ display: "flex", flexDirection: "column", alignItems: "left", mb: 2 }}>
                  <Typography sx={{ color: "#9F9F9F", fontSize: "12px", fontFamily: 'Poppins, Roboto' }}>
                    Mode
                  </Typography>
                  <Typography sx={{ color: "#000", fontSize: "16px", fontFamily: 'Poppins, Roboto', textTransform: 'capitalize' }}>
                    {getCleaningTypeLabel(job.cleaning_type) || '-'}
                  </Typography>
                </Grid>
              </Grid>

              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%'
                }}
              >
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      // justifyContent: 'space-between',
                      width: '100%'
                    }}
                  >
                    <AccessTimeFilled sx={{ color: '#9F9F9F', fontSize: '20px' }} />
                    <Typography sx={{ ml: '4px', fontSize: '12px', color: '#9F9F9F', fontFamily: 'Poppins, Roboto' }}>
                      {isCompleted ? "Completed Time" : "Estimated Completion Time"}
                    </Typography>
                  </Box>
                  {isCompleted && !!job.completed_time ? (
                    <Typography sx={{ fontSize: '18px', ml: '24px', mt: '2px', color: '#000', fontFamily: 'Poppins, Roboto' }}>
                      {(isCompleted && !!job.completed_time) && dayjs(job.completed_time).format("DD MMM YYYY, hh:mm A")}
                    </Typography>
                  ) : (
                    <Typography sx={{ fontSize: '18px', ml: '24px', mt: '2px', color: '#000', fontFamily: 'Poppins, Roboto' }}>
                      {(!isCancelled && !isFailed && !isCompleted) ? estimatedTime() : (isCompleted && !!job.completed_time ? dayjs(job.completed_time).format("DD MMM YYYY, hh:mm A") : "-")}
                    </Typography>
                  )}
                </Box>

                <Box>
                  <Button
                    variant="outlined"
                    color="error"
                    sx={(theme) => ({
                      minWidth: '100px',
                      minHeight: '40px',
                      fontFamily: 'Poppins, Roboto'
                    })}
                    onClick={handleCancelJob}
                    disabled={isCancelled || isFailed || isCompleted}
                  >
                    Cancel
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
        </>
      )}
    </Stack>
  );
}